import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const DIVIDER_LINE_COLOR = '#dddddd';
const DIVIDER_TEXT_COLOR = '#999999';

const GoogleButtonGroup = styled('div')`
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
`;

const Divider = styled('div')`
  align-items: center;
  display: flex;
  gap: 12px;
  margin: 15px 0;
  width: 100%;
`;

const DividerLine = styled('hr')`
  border: none;
  border-top: 1px solid ${DIVIDER_LINE_COLOR};
  flex: 1;
  margin: 0;
`;

const DividerText = styled('span')`
  color: ${DIVIDER_TEXT_COLOR};
  font-family: 'Nunito Sans', sans-serif;
  font-size: 12px;
  text-transform: uppercase;
`;

// Shared "Continue with Google" entry point, reused across the email,
// existing-user, and new-user steps.
const IdntyGoogleOption = ({ onGoogleError, onGoogleSuccess }) => (
  <>
    <GoogleButtonGroup>
      <GoogleLogin
        locale='en'
        onError={onGoogleError}
        onSuccess={(credentialResponse) => {
          if (credentialResponse.credential) {
            onGoogleSuccess(credentialResponse.credential);
          }
        }}
        text='continue_with'
      />
    </GoogleButtonGroup>
    <Divider>
      <DividerLine />
      <DividerText>or</DividerText>
      <DividerLine />
    </Divider>
  </>
);

IdntyGoogleOption.propTypes = {
  onGoogleError: PropTypes.func.isRequired,
  onGoogleSuccess: PropTypes.func.isRequired,
};

export default IdntyGoogleOption;
